/**
 * svg_file is stored as PostgreSQL bytea-as-text (`\x` + hex of UTF-8 bytes)
 * on create (multipart file insert). JSON updates must use the same encoding.
 * Loaders accept both that hex form and raw SVG XML.
 */

export function decodeSvgFile(raw: unknown): string {
  if (raw == null) return '';
  const value = typeof raw === 'string' ? raw : String(raw);
  const trimmed = value.trim();
  if (!trimmed) return '';
  if (trimmed.includes('<svg') || trimmed.includes('<SVG')) {
    return value;
  }
  let hex = trimmed;
  if (hex.startsWith('\\x') || hex.startsWith('\\X')) hex = hex.slice(2);
  else if (/^x[0-9a-fA-F]{8,}/.test(hex)) hex = hex.slice(1);
  hex = hex.replace(/\s+/g, '');
  if (hex.length < 8 || hex.length % 2 !== 0 || /[^0-9a-fA-F]/.test(hex)) {
    return value;
  }
  const bytes = new Uint8Array(hex.length / 2);
  for (let i = 0; i < hex.length; i += 2) {
    bytes[i / 2] = parseInt(hex.substr(i, 2), 16);
  }
  return new TextDecoder('utf-8').decode(bytes);
}

export function encodeSvgFileForDb(svgString: string): string {
  const bytes = new TextEncoder().encode(svgString);
  let hex = '';
  for (let i = 0; i < bytes.length; i += 1) {
    hex += bytes[i].toString(16).padStart(2, '0');
  }
  return `\\x${hex}`;
}
